import { LabelQuestionConfig } from '@gripp/shared-logic';
import {
  RoutineQuestionAdminForm,
  RoutineQuestionAdminFormProps,
} from '../types';

export const LabelQuestionAdminForm: RoutineQuestionAdminForm<
  LabelQuestionConfig
> = (props: RoutineQuestionAdminFormProps<LabelQuestionConfig>) => {
  //TODO: For now we don't have an admin form for this question type
  return null;
};
